/**
 * API rows often use booleans; AzilisSwitch compares `which` to choice1/choice2 strings.
 * Coerce at the table cell only (keeps Switch dumb; avoids inverting labels in the widget).
 * When choice order is inverted (e.g. No | Yes), map true/false by label meaning.
 */
export function booleanToSwitchWhich(raw, column) {
  if (raw !== true && raw !== false) return raw;
  const c1 = column.choice1 || "Yes";
  const c2 = column.choice2 || "No";
  const yesLike = (v) =>
    v === "Yes" || v === "yes" || v === "YES" || v === true || v === "true";
  const noLike = (v) =>
    v === "No" || v === "no" || v === "NO" || v === false || v === "false";

  if (raw === true) {
    if (yesLike(c1)) return c1;
    if (yesLike(c2)) return c2;
    return c1;
  }
  if (noLike(c1)) return c1;
  if (noLike(c2)) return c2;
  return c2;
}

/** CSS class for Lovable yes/no selected segment (first = choice1, second = choice2). */
export function getLovableSwitchPositionClass(which, column) {
  if (which == null || which === "") return "lovable-switch--none";
  const c1 = column.choice1 || "Yes";
  const c2 = column.choice2 || "No";
  const c3 = column.choice3;
  const v3 = column.value3 ?? c3;
  if (v3 != null && (which === v3 || which === c3)) return "lovable-switch--third";
  if (which === c1) return "lovable-switch--first";
  if (which === c2) return "lovable-switch--second";
  return "lovable-switch--none";
}
